export const SITE_NAME = "智慧路灯云平台系统";
export const ACCOUNT_MAP = {
    address: '江苏省扬州市高邮市菱塘回族乡扬州福瑞达光电科技有限公司',
    center: [119.255027, 32.689979]
}